function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M21.5689112,8.4312947 C21.2365503,8.09865934 20.7031887,8.09865934 20.3705141,8.4312947 L14.9999608,13.801215 L9.62979955,8.4312947 C9.29704655,8.09865934 8.76376341,8.09865934 8.43132411,8.4312947 C8.09864954,8.76369481 8.09864954,9.29691509 8.43132411,9.62962886 L13.8018775,14.999157 L8.43132411,20.3690773 C8.09864954,20.7017127 8.09864954,21.2350113 8.43132411,21.567333 C8.59428916,21.7305925 8.81395477,21.8181818 9.02750329,21.8181818 C9.24073813,21.8181818 9.4603253,21.7367089 9.62336878,21.567333 L14.9938437,16.1974128 L20.3643187,21.567333 C20.5273621,21.7305925 20.7469493,21.8181818 20.9601841,21.8181818 C21.1798497,21.8181818 21.3933983,21.7367089 21.5563633,21.567333 C21.8890379,21.2350113 21.8890379,20.7017127 21.5563633,20.3690773 L16.1983578,14.999157 L21.5689112,9.62962886 C21.901272,9.29691509 21.901272,8.76369481 21.5689112,8.4312947 Z",
  transform: "translate(-8 -8)"
});

var SvgIconClose = function SvgIconClose(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-close.8db8b599.svg";
export { ForwardRef as ReactComponent };